
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/detail/[id]",
      function () {
        return require("private-next-pages/brands/detail/[id].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/detail/[id]"])
      });
    }
  